module.exports = {
  fontFamily: {
    body: ['Basier Circle', 'Arial', 'Helvetica', 'sans-serif'],
  },
};
